import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {menu_template} from "../../../common/js/vnKnockoutJsTemplates/menu_template";
import {userSection_template} from "./userSection_template";

declare var ko: any;

export class appHeader_template extends vnTemplate{

    protected menu : menu_template;
    protected userSection : userSection_template;

    protected getTemplateHtml(): string{
        return /*html*/`
    <div class="w-left">
        <nav>
           ${this.menu.getHtmlBuild()}
        </nav>
    </div>
    <div class="w-center"></div>
    <div class="w-right">
        <nav>
            <ul class="main-nav">
                <li class="main-nav-item">
                    ${this.userSection.getHtmlBuild()}
                </li>
                <li class="main-nav-item dropdown">
                    <a class="main-nav-link icon i-settings i-dropdown-simple dropdown-toggle"><span class="hidden-text">Settings</span></a>
                    <ul class="dropdown-list">
                        <li class="main-nav-item">
                            <a href="/users/" class="main-nav-link icon i-user">users</a>
                        </li>
                        <li class="main-nav-item">
                            <a href="/logs/" class="main-nav-link icon i-log">logs</a>
                        </li>
                        <li class="main-nav-item">
                            <a href="/tasks/" class="main-nav-link icon i-task">tasks</a>
                        </li>
                        <li class="main-nav-item" data-bind="{visible: isRolesVisible}">
                            <a href="/roles" class="main-nav-link icon i-role">roles</a>
                        </li>
                    </ul>
                </li>
                
                <li class="main-nav-item">
                    <a class="main-nav-link icon i-logout" data-bind="event: { click: onClickLogOutAction}" type="button"><span class="hidden-text"Logout</span></a>
                </li>
            </ul>
        </nav>
    </div>
            `;
    }

    protected initPartial(): void {
        this.menu = new menu_template("menu", this.getTemplateViewModel(), this.caller);
        this.userSection = new userSection_template("userSection", this.getTemplateViewModel(), this.caller)
    }

    protected getTemplateName(): string{
        return "appHeader-template";
    }

    protected getMainElementClasses(): Array<string>{
    	return ["w-justify"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return  {    userPicture: ko.observable("")
        			,userFullName: ko.observable("")
        			,profileLink: ko.observable("")
                    ,projectsCount: ko.observable("")
                    ,totalEarnings: ko.observable("")
                    ,isUserStatsVisible: ko.observable(false)
                    ,isRolesVisible: ko.observable(false)
                    ,isGoalsVisible: ko.observable(false)
                    ,isGroupsVisible: ko.observable(false)
        			,onClickLogOutAction: function(data, event){ huit_neuf_this.onClickLogOutAction(); }
                };
    }
    public setUserImageSrc(src: string): void{
    	this.viewModel[this.idElement].userPicture(src);
    }
    public setUserFullName(fullName: string): void{
    	this.viewModel[this.idElement].userFullName(fullName);
    }
    public setProfilePageLink(link: string): void{
    	this.viewModel[this.idElement].profileLink(link);
    }
    public setProjectsCount(projectsCount: number): void{
        this.viewModel[this.idElement].projectsCount(projectsCount);
    }
    public setTotalEarnings(totalEarnings: string): void{
        this.viewModel[this.idElement].totalEarnings(totalEarnings);
    }
    public setIsUserStatsVisible(isUserStatsVisible: boolean): void{
        this.viewModel[this.idElement].isUserStatsVisible(isUserStatsVisible);
    }
    public setIsRolesVisible(isRolesVisible: boolean): void{
        this.viewModel[this.idElement].isRolesVisible(isRolesVisible);
    }
    public setIsGoalsVisible(isGoalsVisible: boolean): void{
        this.viewModel[this.idElement].isGoalsVisible(isGoalsVisible);
    }
    public setIsGroupsVisible(isGroupsVisible: boolean): void{
        this.viewModel[this.idElement].isGroupsVisible(isGroupsVisible);
    }

    public setMenu(menu): void {
        this.menu.setMenus(menu)   ;
    }
    public setUser(user) : void {
        this.userSection.setUser(user);
    }

    protected onClickLogOutAction(){
    	this.caller.logOut();
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/appHeader_template.ts